import { useMemo } from 'react';
import { useInputStore } from '@/stores/useInputStore';
import { useBushingStore } from '@/stores/useBushingStore';
import { PLOT_AXES_CONFIG } from '@/constants/plotAxes';

interface TargetPoint {
  x: number | null;
  y: number | null;
}

/**
 * Reads target stiffness inputs and computes (x, y) target points
 * for each of the two scatter charts based on the current bushing type.
 */
export function useTargetMarkers(): [TargetPoint, TargetPoint] {
  const targets = useInputStore((s) => s.target.targets);
  const bushingType = useBushingStore((s) => s.bushingType);

  return useMemo(() => {
    const [axes1, axes2] = PLOT_AXES_CONFIG[bushingType];

    const point1: TargetPoint = {
      x: targets[axes1.xCol] ?? null,
      y: targets[axes1.yCol] ?? null,
    };

    const point2: TargetPoint = {
      x: targets[axes2.xCol] ?? null,
      y: targets[axes2.yCol] ?? null,
    };

    return [point1, point2];
  }, [targets, bushingType]);
}
